// extracted by mini-css-extract-plugin
export default {"sectors":"Sectors_sectors__aYIou","sectors__title":"Sectors_sectors__title__7K73C","sectorsBody":"Sectors_sectorsBody__JeMmh"};